import React from 'react'

const Pytm10 = () => {
    return (
        <div className='container'>
            <h1>Coin Change</h1>
            <p>Given a value N, if we want to make change for N cents, and we have infinite supply of each of S = &#123; S1, S2, .. , Sm&#125; valued coins, how many ways can we make the change? The order of coins doesn’t matter.<br/>
            For example, for N = 4 and S = &#123;1,2,3&#125;, there are four solutions: &#123;1,1,1,1&#125;,&#123;1,1,2&#125;,&#123;2,2&#125;,&#123;1,3&#125;. So output should be 4. For N = 10 and S = &#123;2, 5, 3, 6&#125;, there are five solutions: &#123;2,2,2,2,2&#125;, &#123;2,2,3,3&#125;, &#123;2,2,6&#125;, &#123;2,3,5&#125; and &#123;5,5&#125;. So the output should be 5.<br/>

            &nbsp;</p>
            <pre className='containers'>{`C() --> count()
                             C({1,2,3}, 5)                     
                           /              /    
                         /                  /                  
             C({1,2,3}, 2)                 C({1,2}, 5)
            /        /                      /       /         
           /          /                    /          /   
C({1,2,3}, -1)  C({1,2}, 2)        C({1,2}, 3)    C({1}, 5)
               /     /             /      /           /      /
             /        /           /        /         /         /
    C({1,2},0)  C({1},2)   C({1,2},1) C({1},3)    C({1}, 4)  C({}, 5)
                   /  /     /  /        / /         /      /         
                  /    /   /    /     /    /       /        /  
                .      .  .     .   .     .   C({1}, 3) C({}, 4)
                                               /  / 
                                              /    /   
                                             .      .`}</pre>
<p>Since same suproblems are called again, this problem has Overlapping Subprolems property. So the Coin Change problem has both properties of a dynamic programming problem. Like other typical Dynamic Programming(DP) problems, recomputations of same subproblems can be avoided by constructing a temporary array table[][] in bottom up manner.<br/>

<strong>Dynamic Programming Solution</strong>&nbsp;<br/>


&nbsp;</p>
        <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">C</label>


<div class="tab-content-wrapper">
 <div id="tab-content-1" class="tab-content">
 <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ program for coin change problem.</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="color1 bold">int</code> <code class="plain">count( </code><code
            class="color1 bold">int</code> <code class="plain">S[], </code><code class="color1 bold">int</code> <code
            class="plain">m, </code><code class="color1 bold">int</code> <code class="plain">n )</code></div>
    <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">i, j, x, y;</code></div>
    <div class="line number9 index8 alt2">&nbsp;</div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// We need n+1 rows as the table</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// is constructed in bottom up</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// manner using the base case 0</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// value case (n = 0)</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">table[n + 1][m];</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Fill the enteries for 0</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// value case (n = 0)</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(i = 0; i &lt; m; i++)</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[0][i] = 1;</code></div>
    <div class="line number20 index19 alt1">&nbsp;</div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Fill rest of the table entries</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// in bottom up manner</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(i = 1; i &lt; n + 1; i++)</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(j = 0; j &lt; m; j++)</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Count of solutions including S[j]</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x = (i-S[j] &gt;= 0) ? table[i - S[j]][j] : 0;</code></div>
    <div class="line number29 index28 alt2">&nbsp;</div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Count of solutions excluding S[j]</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">y = (j &gt;= 1) ? table[i][j - 1] : 0;</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// total count</code></div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[i][j] = x + y;</code></div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">table[n][m - 1];</code></div>
    <div class="line number38 index37 alt1"><code class="plain">&#125;</code></div>
    <div class="line number39 index38 alt2">&nbsp;</div>
    <div class="line number40 index39 alt1"><code class="comments">// Driver Code</code></div>
    <div class="line number41 index40 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number42 index41 alt1"><code class="plain">&#123;</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">arr[] = &#123;1, 2, 3&#125;;</code></div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">m = </code><code class="keyword bold">sizeof</code><code
            class="plain">(arr)/</code><code class="keyword bold">sizeof</code><code class="plain">(arr[0]);</code>
    </div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">n = 4;</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; count(arr, m, n);</code></div>
    <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number48 index47 alt1"><code class="plain">&#125;</code></div>
    <div class="line number49 index48 alt2">&nbsp;</div>
    <div class="line number50 index49 alt1"><code class="comments">// This code is contributed</code></div>
    <div class="line number51 index50 alt2"><code class="comments">// by Akanksha Rai(Abby_akku)</code></div>
</div>
</div>
 <div id="tab-content-2" class="tab-content">
 <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">/* Dynamic Programming Java implementation of Coin</code></div>
    <div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">Change problem */</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">import</code> <code
            class="plain">java.util.Arrays;</code></div>
    <div class="line number4 index3 alt1">&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="keyword">class</code> <code class="plain">CoinChange</code></div>
    <div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">long</code> <code class="plain">countWays(</code><code
            class="keyword">int</code> <code class="plain">S[], </code><code class="keyword">int</code> <code
            class="plain">m, </code><code class="keyword">int</code> <code class="plain">n)</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">//Time complexity of this function: O(mn)</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">//Space Complexity of this function: O(n)</code></div>
    <div class="line number11 index10 alt2">&nbsp;</div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// table[i] will be storing the number of solutions</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// for value i. We need n+1 rows as the table is</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// constructed in bottom up manner using the base</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// case (n = 0)</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">long</code><code class="plain">[] table = </code><code class="keyword">new</code> <code
            class="keyword">long</code><code class="plain">[n+</code><code class="value">1</code><code
            class="plain">];</code></div>
    <div class="line number17 index16 alt2">&nbsp;</div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Initialize all table values as 0</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Arrays.fill(table, </code><code class="value">0</code><code
            class="plain">);&nbsp;&nbsp; </code><code class="comments">//O(n)</code></div>
    <div class="line number20 index19 alt1">&nbsp;</div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Base case (If given value is 0)</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[</code><code class="value">0</code><code class="plain">] = </code><code
            class="value">1</code><code class="plain">;</code></div>
    <div class="line number23 index22 alt2">&nbsp;</div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Pick all coins one by one and update the table[]</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// values after the index greater than or equal to</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// the value of the picked coin</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">i=</code><code class="value">0</code><code class="plain">; i&lt;m; i++)</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">j=S[i]; j&lt;=n; j++)</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[j] += table[j-S[i]];</code></div>
    <div class="line number30 index29 alt1">&nbsp;</div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">table[n];</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number33 index32 alt2">&nbsp;</div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Driver Function to test above function</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String args[])</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">arr[] = &#123;</code><code class="value">1</code><code
            class="plain">, </code><code class="value">2</code><code class="plain">, </code><code
            class="value">3</code><code class="plain">&#125;;</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">m = arr.length;</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">n = </code><code class="value">4</code><code
            class="plain">;</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(countWays(arr, m, n));</code></div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number42 index41 alt1"><code class="plain">&#125;</code></div>
    <div class="line number43 index42 alt2"><code class="comments">// This code is contributed by Pankaj Kumar</code>
    </div>
</div>
  </div> 
 <div id="tab-content-3" class="tab-content">
 <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments"># Dynamic Programming Python implementation of Coin</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># Change problem</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">def</code> <code class="plain">count(S, m, n):</code>
    </div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># We need n+1 rows as the table is constructed</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># in bottom up manner using the base case 0 value</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># case (n = 0)</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table </code><code class="keyword">=</code> <code class="plain">[[</code><code
            class="value">0</code> <code class="keyword">for</code> <code class="plain">x </code><code
            class="keyword">in</code> <code class="functions">range</code><code class="plain">(m)] </code><code
            class="keyword">for</code> <code class="plain">x </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(n</code><code class="keyword">+</code><code
            class="value">1</code><code class="plain">)]</code></div>
    <div class="line number8 index7 alt1">&nbsp;</div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Fill the entries for 0 value case (n = 0)</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(m):</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[</code><code class="value">0</code><code class="plain">][i] </code><code
            class="keyword">=</code> <code class="value">1</code></div>
    <div class="line number12 index11 alt1">&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Fill rest of the table entries in bottom up manner</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(</code><code class="value">1</code><code
            class="plain">, n</code><code class="keyword">+</code><code class="value">1</code><code
            class="plain">):</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">j </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(m):</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Count of solutions including S[j]</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x </code><code class="keyword">=</code> <code class="plain">table[i </code><code
            class="keyword">-</code> <code class="plain">S[j]][j] </code><code class="keyword">if</code> <code
            class="plain">i</code><code class="keyword">-</code><code class="plain">S[j] &gt;</code><code
            class="keyword">=</code> <code class="value">0</code> <code class="keyword">else</code> <code
            class="value">0</code></div>
    <div class="line number19 index18 alt2">&nbsp;</div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Count of solutions excluding S[j]</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">y </code><code class="keyword">=</code> <code class="plain">table[i][j</code><code
            class="keyword">-</code><code class="value">1</code><code class="plain">] </code><code
            class="keyword">if</code> <code class="plain">j &gt;</code><code class="keyword">=</code> <code
            class="value">1</code> <code class="keyword">else</code> <code class="value">0</code></div>
    <div class="line number22 index21 alt1">&nbsp;</div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># total count</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[i][j] </code><code class="keyword">=</code> <code class="plain">x </code><code
            class="keyword">+</code> <code class="plain">y</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">table[n][m</code><code class="keyword">-</code><code
            class="value">1</code><code class="plain">]</code></div>
    <div class="line number27 index26 alt2">&nbsp;</div>
    <div class="line number28 index27 alt1"><code class="comments"># Driver program to test above function</code></div>
    <div class="line number29 index28 alt2"><code class="plain">arr </code><code class="keyword">=</code> <code
            class="plain">[</code><code class="value">1</code><code class="plain">, </code><code
            class="value">2</code><code class="plain">, </code><code class="value">3</code><code class="plain">]</code>
    </div>
    <div class="line number30 index29 alt1"><code class="plain">m </code><code class="keyword">=</code> <code
            class="functions">len</code><code class="plain">(arr)</code></div>
    <div class="line number31 index30 alt2"><code class="plain">n </code><code class="keyword">=</code> <code
            class="value">4</code></div>
    <div class="line number32 index31 alt1"><code class="functions">print</code><code
            class="plain">(count(arr, m, n))</code></div>
    <div class="line number33 index32 alt2">&nbsp;</div>
    <div class="line number34 index33 alt1"><code class="comments"># This code is contributed by Bhavya Jain</code>
    </div>
</div>
</div>
 <div id="tab-content-4" class="tab-content">
 <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C program for coin change problem.</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include&lt;stdio.h&gt;</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="color1 bold">int</code> <code class="plain">count( </code><code
            class="color1 bold">int</code> <code class="plain">S[], </code><code class="color1 bold">int</code> <code
            class="plain">m, </code><code class="color1 bold">int</code> <code class="plain">n )</code></div>
    <div class="line number5 index4 alt2"><code class="plain">&#123;</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">i, j, x, y;</code></div>
    <div class="line number7 index6 alt2">&nbsp;</div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// We need n+1 rows as the table is constructed</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// in bottom up manner using the base case 0</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// value case (n = 0)</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">table[n+1][m];</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Fill the enteries for 0 value case (n = 0)</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(i=0; i&lt;m; i++)</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[0][i] = 1;</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Fill rest of the table entries in bottom</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// up manner&nbsp;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(i = 1; i &lt; n+1; i++)</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(j = 0; j &lt; m; j++)</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Count of solutions including S[j]</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x = (i-S[j] &gt;= 0)? table[i - S[j]][j]: 0;</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Count of solutions excluding S[j]</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">y = (j &gt;= 1)? table[i][j-1]: 0;</code></div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// total count</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">table[i][j] = x + y;</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">table[n][m-1];</code></div>
    <div class="line number34 index33 alt1"><code class="plain">&#125;</code></div>
    <div class="line number35 index34 alt2">&nbsp;</div>
    <div class="line number36 index35 alt1"><code class="comments">// Driver program to test above function</code></div>
    <div class="line number37 index36 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number38 index37 alt1"><code class="plain">&#123;</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">arr[] = &#123;1, 2, 3&#125;;</code></div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">m = </code><code class="keyword bold">sizeof</code><code
            class="plain">(arr)/</code><code class="keyword bold">sizeof</code><code class="plain">(arr[0]);</code>
    </div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">n = 4;</code></div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">" %d "</code><code
            class="plain">, count(arr, m, n));</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number44 index43 alt1"><code class="plain">&#125;</code></div>
</div>
</div>
</div>
</div>
<br /> <br /> <br /> <br /> <br />
  
   </div>
    )
}

export default Pytm10
